<template>
    <md-list-item class="ql-layer-menu-item">
        <md-icon class="ql-color-picker-choice" :style="style()">
        </md-icon>
        <span>{{layer.title}}</span>
        <md-button @click="deleteLayer">
            <md-icon >delete</md-icon>
        </md-button>
    </md-list-item>
</template>

<script>
const LayersLayerLite = {
    name: 'LayersLayerLite',
    props: ['layer'],
    data: function() {
        return {
        };
    },
    computed: {
    },
    methods: {
        style() {
            let val = 'background-color: white;';
            if (this.layer.color) {
                val = 'background-color: ' + this.layer.color + ' !important;';
            }
            return val;
        },
        deleteLayer() {
            this.$emit('deleteLayer', this.layer);
        }
    }
};
export default LayersLayerLite;

</script>

<style lang="scss">
.vc-compact {
    margin: 10px 0;
}
.ql-color-picker {
    width: 100%;
    display: block;
    clear: both;
}
.ql-color-picker-choice {
    margin: 0;
    padding: 0;
    width: 25px;
    height: 25px;
    min-height: 25px;
    min-width: 25px;
    line-height: 25px;
    box-sizing: border-box;
    border: 1px solid black !important;
    margin-right: 15px;
}
.ql-layer-menu-item {
    form {
        z-index: 100;
        text-align: left;
        width: calc(100% - 1em);
        margin-left: 1em;
        span {
            text-align: left;
            margin-left: 0;
            width: 100%;
            height: 100%;
            display: inline-block;
        }
    }
    .sub-list {
        .md-list-item .md-list-item-container > .md-icon:first-child {
            margin-right: 0px;
        }
        margin-left: 16px;
        width: calc(100% - 16px);
    }
}
</style>


// WEBPACK FOOTER //
// layer-lite.vue?6582f244